import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import discordIcon from "../assets/discord-big.svg";
import twitterIcon from "../assets/icons8-x.svg";
import telegramIcon from "../assets/Telegram.svg";
import googlePlayIcon from "../assets/Google-Play-icon-logo.png";
import androidLogo from "../assets/android-logo.png";
// TestFlight link temporarily disabled — DO NOT DELETE, user wants this preserved to re-enable later.
// import testFlightLogo from "../assets/testflight-icon-logo.png";
import loginIcon from "../assets/icons/vuesax/outline/login.svg";
import swapIcon from "../assets/icons/vuesax/outline/arrow-swap.svg";
import cardIcon from "../assets/icons/vuesax/outline/card.svg";
import chartIcon from "../assets/icons/vuesax/outline/chart.svg";
import coinIcon from "../assets/icons/vuesax/outline/coin.svg";
import statusUpIcon from "../assets/icons/vuesax/outline/status-up.svg";
import aiIcon from "../assets/icons/vuesax/outline/AI Icon.svg";
import linkIcon from "../assets/icons/vuesax/outline/link.svg";
import usersIcon from "../assets/icons/vuesax/outline/profile-2user.svg";
import notificationIcon from "../assets/icons/vuesax/outline/notification-bing.svg";
import cardPosIcon from "../assets/icons/vuesax/outline/card-pos.svg";
import billIcon from "../assets/icons/vuesax/outline/bill.svg";
import mayaIcon from "../assets/Maya.svg";
import chainflipIcon from "../assets/chainflip.svg";
import ProofIcon from "../assets/PROOF-solid-white 1.svg";
import thorchainBrand from "../assets/thorchain.svg";
import welcomeScreenShot from "../assets/figmapp/Welcome Screen.jpg";
import homeScreenShot from "../assets/figmapp/Home Page.jpg";
import assetsScreenShot from "../assets/figmapp/Assets Page - default.jpg";
import swapScreenShot from "../assets/figmapp/Market Page - Default Swap.jpg";
import aiChatScreenShot from "../assets/figmapp/AI Chat.jpg";
import alertsScreenShot from "../assets/figmapp/Notifications Price alerts default.jpg";
import bitcoin from "../assets/chains/Bitcoin.png";
import litecoin from "../assets/chains/Litecoin.png";
import dogecoin from "../assets/chains/dogecoin.png";
import bitcoinCash from "../assets/chains/Bitcoin-cash.png";
import dash from "../assets/chains/Dash.png";
import zcash from "../assets/chains/Zcash.png";
import solana from "../assets/chains/solana.png";
import thorchain from "../assets/chains/thorchain.png";
import mayaChain from "../assets/chains/maya-chain.png";
import cosmos from "../assets/chains/Cosmos.png";
import tron from "../assets/chains/Tron.png";
import cardano from "../assets/chains/Cardano.png";
import ripple from "../assets/chains/Ripple.png";
import near from "../assets/chains/Near.png";
import eth from "../assets/chains/Ethereum.png";
import bsc from "../assets/chains/bsc.png";
import polygon from "../assets/chains/polygon.png";
import optimism from "../assets/chains/Optimism.png";
import arbitrum from "../assets/chains/Arbitrum.png";
import base from "../assets/chains/base.png";
import avalanche from "../assets/chains/Avalanche.png";
import {
  getAppStoreLinkProps,
  GOOGLE_PLAY_DOWNLOAD_PATH,
  // TestFlight link temporarily disabled — DO NOT DELETE, user wants this preserved to re-enable later.
  // hasTestFlightInvite,
  // TESTFLIGHT_URL,
} from "../utils/appLinks";
import { useApkRelease } from "../utils/useApkRelease";
import { ApkModal } from "./Components/ApkModal";

import Footer from "./Components/Footer";
import { AmbientCanvas, AmbientOrbits } from "./Components/AmbientStage";
import { BybTokenSection } from "./Components/BybTokenSection";
import ProductPillars from "./Components/ProductPillars";
import "./HomeAlive.css";

// Video is served from /public so it's never bundled into the JS graph — the
// dev server just streams it on demand when the hero IntersectionObserver
// decides it's time to load.
const launchVideo = `${process.env.PUBLIC_URL || ""}/media/biorvault-launch.mp4`;

const ALL_CHAINS = [
  { name: "Bitcoin", logo: bitcoin, category: "pow" },
  { name: "Litecoin", logo: litecoin, category: "pow" },
  { name: "Dogecoin", logo: dogecoin, category: "pow" },
  { name: "Bitcoin Cash", logo: bitcoinCash, category: "pow" },
  { name: "Dash", logo: dash, category: "pow" },
  { name: "Zcash", logo: zcash, category: "pow" },
  { name: "Solana", logo: solana, category: "layer1" },
  { name: "THORChain", logo: thorchain, category: "layer1" },
  { name: "Maya Protocol", logo: mayaChain, category: "layer1" },
  { name: "Cosmos", logo: cosmos, category: "layer1" },
  { name: "Tron", logo: tron, category: "layer1" },
  { name: "Cardano", logo: cardano, category: "layer1" },
  { name: "Ripple", logo: ripple, category: "layer1" },
  { name: "Near", logo: near, category: "layer1" },
  { name: "Ethereum", logo: eth, category: "evm" },
  { name: "BSC", logo: bsc, category: "evm" },
  { name: "Polygon", logo: polygon, category: "evm" },
  { name: "Optimism", logo: optimism, category: "evm" },
  { name: "Arbitrum", logo: arbitrum, category: "evm" },
  { name: "Base", logo: base, category: "evm" },
  { name: "Avalanche", logo: avalanche, category: "evm" },
];

const SUPPORTED_NETWORK_COUNT = ALL_CHAINS.length;

const CHAIN_FILTERS = [
  { key: "all", label: "All networks" },
  { key: "pow", label: "Proof of Work" },
  { key: "layer1", label: "Cosmos + Layer 1" },
  { key: "evm", label: "EVM" },
];

const CHAIN_CATEGORY_LABELS = {
  pow: "PoW",
  layer1: "Layer 1",
  evm: "EVM",
};

const HERO_METRICS = [
  { value: "0.4%",                    label: "Cross-chain swap fee"  },
  { value: "$40",                     label: "Fee on a $10k swap"    },
  { value: `${SUPPORTED_NETWORK_COUNT}+`, label: "Supported networks" },
  { value: "Global",                  label: "Availability"          },
];

const CORE_FEATURES = [
  {
    title: "Social Login",
    desc: "Sign in with Google or X and start with full self-custody without needing a seed phrase on day one.",
    badge: "Live",
    icon: loginIcon,
  },
  {
    title: "Cross-Chain Swaps",
    desc: "Swap across chains inside the wallet with a simple product flow designed for true cross-chain movement.",
    badge: "Live + expanding",
    icon: swapIcon,
  },
  {
    title: "Fiat On/Off Ramp",
    desc: "Buy crypto with card or bank transfer, and sell back to fiat, all inside the app.",
    badge: "Live + expanding",
    icon: cardIcon,
  },
  {
    title: "Portfolio Tracker",
    desc: "View balances, charts, and holdings across all accounts and supported chains in one place.",
    badge: "Live",
    icon: chartIcon,
  },
  {
    title: "Token Intelligence",
    desc: "Get charts, tokenomics, market data, and explorer links for every token without leaving the wallet.",
    badge: "Live",
    icon: coinIcon,
  },
  {
    title: "Market Overview Dashboard",
    desc: "Track BTC halving, Fear & Greed, Altcoin Season, ETH gas, and dominance metrics from one dashboard.",
    badge: "Live",
    icon: statusUpIcon,
  },
  {
    title: "MindVault AI",
    desc: "Ask crypto questions from the search bar and get answers instantly without breaking your workflow.",
    badge: "Live",
    icon: aiIcon,
  },
  {
    title: "WalletConnect",
    desc: "Connect to dApps by scanning a QR code and keep full Web3 access inside a self-custody wallet.",
    badge: "Live",
    icon: linkIcon,
  },
  {
    title: "Multi-Account Management",
    desc: "Manage multiple wallets under one app with structured child account support.",
    badge: "Live",
    icon: usersIcon,
  },
  {
    title: "Price Alerts",
    desc: "Create custom token alerts so the app watches the market for you.",
    badge: "Live + expanding",
    icon: notificationIcon,
  },
  {
    title: "Payment Cards",
    desc: "Card-based spending is on the roadmap so the wallet can extend into everyday payments.",
    badge: "Coming soon",
    icon: cardPosIcon,
  },
  {
    title: "Bill Pay",
    desc: "Pay bills directly from your wallet without converting to fiat first.",
    badge: "Coming soon",
    icon: billIcon,
  },
];

const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Create your account",
    detail: "Use Google or X, import an existing wallet, or create one with a seed phrase.",
    image: welcomeScreenShot,
    imageAlt: "BiorVault welcome screen",
  },
  {
    step: "02",
    title: "Add chains and tokens",
    detail: "Work across EVM, Cosmos, custom tokens, and custom chains from one app shell.",
    image: assetsScreenShot,
    imageAlt: "BiorVault assets page",
  },
  {
    step: "03",
    title: "Use the wallet daily",
    detail: "Send, receive, swap, track, and soon spend without jumping between tools.",
    image: swapScreenShot,
    imageAlt: "BiorVault swap screen",
  },
];

const PARTNERS = [
  { src: mayaIcon, alt: "Maya Protocol", href: "https://www.mayaprotocol.com/", imgClass: "h-10 w-auto", meta: "Protocol layer" },
  { src: chainflipIcon, alt: "Chainflip", href: "https://chainflip.io/", imgClass: "h-10 w-auto", meta: "Protocol layer" },
  { src: thorchainBrand, alt: "THORChain", href: "https://thorchain.org/", imgClass: "h-10 w-auto partner-card__logo--thorchain", meta: "Protocol layer" },
  { src: ProofIcon, alt: "Proof", href: "https://proofplatform.io/", imgClass: "h-10 w-auto", meta: "Incubator" },
];

const ROADMAP_COLUMNS = [
  {
    title: "BiorVault",
    subtitle: "Mobile app",
    tone: "mint",
    lead: "The core wallet product, focused on making self-custody more usable in everyday crypto flows.",
    items: [
      { label: "Markets", title: "xStocks swapping", state: "Done" },
      { label: "Access", title: "On/off ramp aggregator", state: "Done" },
      { label: "Utility", title: "Payment cards", state: "In progress" },
      { label: "Utility", title: "Pay bills", state: "In progress" },
      { label: "Growth", title: "Referral system", state: "Done" },
      { label: "Growth", title: "Cashback system", state: "Done" },
      { label: "Integration", title: "BCH CashTokens integration", state: "In progress" },
      { label: "Integration", title: "CauldronSwap integration", state: "In progress" },
      { label: "Partnership", title: "Surprise partnership", state: "Planned" },
      { label: "Partnership", title: "Price alert partnership / expansion", state: "Planned" },
    ],
  },
  {
    title: "BiorSwap",
    subtitle: "Web app",
    tone: "violet",
    lead: "The web app product focused on cross-chain aggregation, wallet connectivity, and release readiness.",
    items: [
      { label: "Infra", title: "Bought BiorSwap domain", state: "Done" },
      { label: "Core", title: "Build aggregator", state: "Done" },
      { label: "Access", title: "Support for connecting wallets to the website", state: "Done" },
      { label: "Release", title: "Testing before release", state: "In progress" },
      { label: "Product", title: "Dark mode", state: "Done" },
      { label: "Product", title: "Renovated swap UI", state: "Done" },
      { label: "Integration", title: "Direct BiorVault connection to BiorSwap", state: "Planned" },
      { label: "Integration", title: "API & widget for integrations", state: "Planned" },
    ],
  },
  {
    title: "BiorBrowse",
    subtitle: "Browser extension",
    tone: "gold",
    lead: "The newest product, bringing self-custody into the desktop browser as an extension.",
    items: [
      { label: "Design", title: "Create design", state: "Done" },
      { label: "Core", title: "Extension scaffold and build pipeline", state: "In progress" },
      { label: "Security", title: "Key management and secure storage", state: "In progress" },
      { label: "Core", title: "Multi-chain account view", state: "In progress" },
      { label: "Core", title: "Transaction signing and approvals", state: "In progress" },
      { label: "Access", title: "dApp connection support", state: "In progress" },
      { label: "Integration", title: "Compatible with BiorSwap", state: "Planned" },
      { label: "Integration", title: "Compatible with BiorVault", state: "Planned" },
      { label: "Release", title: "Chrome Web Store submission", state: "Planned" },
      { label: "Release", title: "Brave and Firefox support", state: "Planned" },
      { label: "Release", title: "Live product", state: "Planned" },
    ],
  },
];

// Rendered as a single centered block under the three roadmap columns: these
// are cross-product items, not BiorBrowse work.
const ROADMAP_FOOTER_SECTIONS = [
  {
    heading: "Other upcoming products",
    items: [
      { label: "Infra", title: "Data provider + wallet SDK", state: "Planned" },
      { label: "AI", title: "Cortex AI", state: "Planned" },
    ],
  },
  {
    heading: "Other planned features",
    items: [
      { label: "Access", title: "Built-in browser", state: "BiorVault" },
      { label: "Security", title: "Cold storage / hardware wallet support", state: "BiorVault" },
      { label: "Trust", title: "Public audit", state: "BiorVault" },
    ],
  },
];

const SOCIALS = [
  { href: "https://discord.gg/hBs477K7AG", icon: discordIcon, label: "Discord" },
  { href: "https://x.com/biorlabs", icon: twitterIcon, label: "X" },
  { href: "https://t.me/BiorLabsPortal", icon: telegramIcon, label: "Telegram" },
];

const PRODUCT_SHOWCASE = [
  {
    title: "Portfolio overview",
    caption: "Balances, allocations, and market context in one place.",
    image: homeScreenShot,
    alt: "BiorVault home portfolio screen",
  },
  {
    title: "Cross-chain swap flow",
    caption: "Built for simple route selection and true cross-chain movement.",
    image: swapScreenShot,
    alt: "BiorVault swap flow screen",
  },
  {
    title: "MindVault AI",
    caption: "Answers, research, and discovery without leaving the app.",
    image: aiChatScreenShot,
    alt: "BiorVault AI chat screen",
  },
  {
    title: "Price alerts",
    caption: "Watchlists and token triggers that stay close to the portfolio.",
    image: alertsScreenShot,
    alt: "BiorVault price alerts screen",
  },
];

function HeroVideo({ src, poster }) {
  const shellRef = useRef(null);
  const videoRef = useRef(null);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updateMotionPreference = () => {
      setPrefersReducedMotion(mediaQuery.matches);
    };

    updateMotionPreference();

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", updateMotionPreference);
      return () => mediaQuery.removeEventListener("change", updateMotionPreference);
    }

    mediaQuery.addListener(updateMotionPreference);
    return () => mediaQuery.removeListener(updateMotionPreference);
  }, []);

  useEffect(() => {
    if (prefersReducedMotion || typeof window === "undefined") {
      return undefined;
    }

    let observer;
    let timeoutId = null;
    let idleCallbackId = null;
    let cancelled = false;

    const scheduleVideoLoad = () => {
      if (typeof window.requestIdleCallback === "function") {
        idleCallbackId = window.requestIdleCallback(() => {
          if (!cancelled) {
            setShouldLoadVideo(true);
          }
        }, { timeout: 1200 });
        return;
      }

      timeoutId = window.setTimeout(() => {
        if (!cancelled) {
          setShouldLoadVideo(true);
        }
      }, 700);
    };

    const shell = shellRef.current;

    if (shell && typeof window.IntersectionObserver === "function") {
      observer = new window.IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          scheduleVideoLoad();
          observer.disconnect();
        }
      }, { rootMargin: "180px 0px" });

      observer.observe(shell);
    } else {
      scheduleVideoLoad();
    }

    return () => {
      cancelled = true;
      observer?.disconnect();

      if (idleCallbackId !== null && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleCallbackId);
      }

      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [prefersReducedMotion]);

  useEffect(() => {
    if (prefersReducedMotion || !shouldLoadVideo) {
      return undefined;
    }

    const video = videoRef.current;

    if (!video) {
      return undefined;
    }

    const syncAutoplayAttributes = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute("muted", "");
      video.setAttribute("autoplay", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "true");
    };

    const attemptPlay = () => {
      syncAutoplayAttributes();

      try {
        const playPromise = video.play?.();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      } catch (_) {
        // Ignore autoplay failures triggered by browser policy or test environments.
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        attemptPlay();
      }
    };

    syncAutoplayAttributes();
    if (video.readyState >= 2) {
      attemptPlay();
    }

    video.addEventListener("loadeddata", attemptPlay);
    video.addEventListener("canplay", attemptPlay);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      video.removeEventListener("loadeddata", attemptPlay);
      video.removeEventListener("canplay", attemptPlay);

      try {
        video.pause?.();
      } catch (_) {
        // Ignore pause errors in non-media test environments.
      }
    };
  }, [prefersReducedMotion, shouldLoadVideo]);

  return (
    <div ref={shellRef} className="hero-v2__video-shell">
      {!prefersReducedMotion && shouldLoadVideo ? (
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          disablePictureInPicture
          disableRemotePlayback
          aria-label="BiorVault app preview video"
          className="hero-v2__video-media"
        >
          <source src={`${src}#t=0.001`} type="video/mp4" />
        </video>
      ) : null}
    </div>
  );
}

function StoreButton({
  href,
  icon,
  eyebrow,
  label,
  subtle,
  iconClassName = "",
  target = "_blank",
  rel = "noreferrer",
  onClick,
}) {
  const cls = `store-button ${subtle ? "store-button--subtle" : ""}`;
  const inner = (
    <>
      <div className={`store-button__icon ${iconClassName}`.trim()}>{icon}</div>
      <div className="store-button__copy">
        <span className="store-button__eyebrow">{eyebrow}</span>
        <span className="store-button__label">{label}</span>
      </div>
      <div className="store-button__arrow" aria-hidden="true">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5l5 5-5 5" />
        </svg>
      </div>
    </>
  );
  if (onClick) {
    return <button type="button" onClick={onClick} className={cls}>{inner}</button>;
  }
  return (
    <a href={href} target={target} rel={rel} className={cls}>{inner}</a>
  );
}

export const Home = () => {
  const [chainSearch, setChainSearch] = useState("");
  const [chainFilter, setChainFilter] = useState("all");
  const [apkModalOpen, setApkModalOpen] = useState(false);
  const apk = useApkRelease();
  const appStoreLinkProps = getAppStoreLinkProps();
  // TestFlight link temporarily disabled — DO NOT DELETE, user wants this preserved to re-enable later.
  // const showTestFlightButton = hasTestFlightInvite();

  const normalizedSearch = chainSearch.trim().toLowerCase();
  const filteredChains = ALL_CHAINS.filter((chain) => (
    (chainFilter === "all" || chain.category === chainFilter) &&
    chain.name.toLowerCase().includes(normalizedSearch)
  ));
  const showEvmCard = normalizedSearch === "" && (chainFilter === "all" || chainFilter === "evm");
  const showCosmosCard = normalizedSearch === "" && (chainFilter === "all" || chainFilter === "layer1");
  const hasVisibleChains = filteredChains.length > 0 || showEvmCard || showCosmosCard;

  return (
    <>
      <div className="landing-shell w-full">
        <div className="landing-shell__grain" />
        <div className="landing-shell__aurora landing-shell__aurora--one" />
        <div className="landing-shell__aurora landing-shell__aurora--two" />

        <section
          className="hero-v2 relative overflow-hidden px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8"
          style={{ paddingTop: "calc(7rem + var(--safe-area-top))" }}
        >
          {/* Living ambient backdrop */}
          <div className="hero-alive-stage" aria-hidden="true">
            <AmbientCanvas density={30} />
            <AmbientOrbits />
          </div>
          <div className="hero-alive-beam" aria-hidden="true" />

          <div className="mx-auto max-w-[73.75rem] relative z-10 flex flex-col items-center text-center">

            {/* H1 */}
            <h1
              className="hero-v2__title font-syne text-white"
              style={{ fontSize: "clamp(2.4rem, 6vw, 4.6rem)", lineHeight: "1.04", fontWeight: 700 }}
            >
              Self-custody made{" "}
              <span className="hero-alive-accent">simple.</span>
            </h1>

            {/* Description */}
            <p className="hero-v2__sub font-dm">
              BiorVault gives you full control of your crypto — social login, multi-chain access,
              true cross-chain swaps, and fiat on/off ramp in one app.
            </p>

            {/* Metric pills */}
            <div className="hero-v2__pills">
              {HERO_METRICS.map((m) => (
                <div key={m.label} className="hero-v2__pill">
                  <span className="hero-v2__pill-value">{m.value}</span>
                  <span className="hero-v2__pill-label">{m.label}</span>
                </div>
              ))}
            </div>

            {/* Social links */}
            <div className="hero-v2__social">
              <div className="hero-social-line">
                {SOCIALS.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noreferrer"
                    className="social-orb"
                    aria-label={social.label}
                  >
                    <img
                      src={social.icon}
                      alt=""
                      aria-hidden="true"
                      className="w-4 h-4 brightness-0 invert opacity-70"
                    />
                  </a>
                ))}
              </div>
            </div>

            {/* Launch video */}
            <HeroVideo src={launchVideo} />

            {/* Download buttons */}
            <div className="hero-v2__downloads">
              <StoreButton
                {...appStoreLinkProps}
                eyebrow="Get it on"
                label="App Store"
                icon={(
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                )}
              />
              <StoreButton
                href={GOOGLE_PLAY_DOWNLOAD_PATH}
                eyebrow="Get it on"
                label="Google Play"
                iconClassName="store-button__icon--google-play"
                icon={<img src={googlePlayIcon} alt="" className="object-contain" />}
              />
              <StoreButton
                onClick={() => setApkModalOpen(true)}
                eyebrow={apk.version ? `v${apk.version} · Direct install` : "Direct install"}
                label="Android APK"
                subtle
                icon={<img src={androidLogo} alt="" className="object-contain" />}
              />
              {/* TestFlight link temporarily disabled — DO NOT DELETE, user wants this preserved to re-enable later.
              {showTestFlightButton ? (
                <StoreButton
                  href={TESTFLIGHT_URL}
                  eyebrow="Early access"
                  label="TestFlight"
                  subtle
                  icon={<img src={testFlightLogo} alt="" className="object-contain" />}
                />
              ) : null}
              */}
            </div>

            <p className="hero-v2__coverage font-dm">
              Our team is working around the clock toward full global coverage, including
              App Store availability in Russia, China, and India.
            </p>

          </div>
        </section>

        <ProductPillars features={CORE_FEATURES} showcase={PRODUCT_SHOWCASE} />

        {/* ── Token + Cards teaser (merged into one section so both blocks
             sit together inside a single viewport on desktop). */}
        <section className="deferred-section relative px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14">
          <div className="mx-auto max-w-7xl flex flex-col gap-4">

            <div className="cards-teaser__header">
              <h2
                className="cards-teaser__title font-syne"
                style={{ fontSize: "clamp(1.4rem, 2.4vw, 1.9rem)", lineHeight: "1.1", fontWeight: 700 }}
              >
                Spend your crypto{" "}
                <span className="hero-alive-accent">anywhere.</span>
              </h2>
              <p className="cards-teaser__sub font-dm">
                BiorVault Cards are coming — real Mastercard products that let you spend directly from your wallet.
              </p>
            </div>

            <div className="cards-teaser__grid">
              {/* Physical Debit Card */}
              <div className="card-preview card-preview--physical">
                <div className="card-preview__img-area">
                  <img src="/assets/Physical card view.svg" alt="BiorVault Physical Debit Card" className="card-preview__img" />
                </div>
                <div className="card-preview__body">
                  <div className="card-preview__badge">
                    <span className="card-preview__badge-dot" aria-hidden="true" />
                    Coming soon
                  </div>
                  <div className="card-preview__title">Physical Debit Card</div>
                  <p className="card-preview__sub font-dm">
                    A reloadable Mastercard with global ATM access and a $100,000 balance limit.
                  </p>
                  <div className="card-preview__bullets">
                    {["KYC-verified — full identity compliance", "ATM withdrawals worldwide", "Up to 3 cards per account", "Crypto top-up with 2.20% fee"].map((b) => (
                      <div key={b} className="card-preview__bullet font-dm">
                        <span className="card-preview__bullet-dot" aria-hidden="true" />
                        {b}
                      </div>
                    ))}
                  </div>
                  <Link to="/cards?card=physical" className="card-preview__cta font-dm">
                    Learn more
                    <svg className="card-preview__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </Link>
                </div>
              </div>

              {/* Virtual Prepaid Card */}
              <div className="card-preview card-preview--virtual">
                <div className="card-preview__img-area">
                  <img src="/assets/Virtual Card.svg" alt="BiorVault Virtual Prepaid Card" className="card-preview__img" />
                </div>
                <div className="card-preview__body">
                  <div className="card-preview__badge">
                    <span className="card-preview__badge-dot" aria-hidden="true" />
                    Coming soon
                  </div>
                  <div className="card-preview__title">Virtual Prepaid Card</div>
                  <p className="card-preview__sub font-dm">
                    Instant digital Mastercard with soft KYC, Apple Pay support, and $400k/month limits.
                  </p>
                  <div className="card-preview__bullets">
                    {["Soft KYC — quick & simple", "Apple Pay & Google Pay ready", "$400,000 monthly spending limit", "36-month validity, no renewals"].map((b) => (
                      <div key={b} className="card-preview__bullet font-dm">
                        <span className="card-preview__bullet-dot" aria-hidden="true" />
                        {b}
                      </div>
                    ))}
                  </div>
                  <Link to="/cards?card=virtual" className="card-preview__cta font-dm">
                    Learn more
                    <svg className="card-preview__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section className="deferred-section relative px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14">
          <div className="mx-auto max-w-7xl">
            <div className="journey-layout">
              <div className="journey-intro">
                <div className="journey-intro__eyebrow">How it works</div>
                <h3 className="journey-intro__title">
                  Three steps to get{" "}
                  <span className="hero-alive-accent">moving.</span>
                </h3>
                <p className="journey-intro__body">
                  BiorVault is designed to reduce the handoff points: one account flow, one wallet surface,
                  and one place to manage the actions people care about most.
                </p>
              </div>

              <div className="journey-track">
                {HOW_IT_WORKS.map((item) => (
                  <div key={item.step} className="journey-step">
                    <div className="journey-step__rail" aria-hidden="true">
                      <span className="journey-step__dot" />
                    </div>
                    <div className="journey-step__content">
                      <div className="journey-step__header">
                        <div>
                          <div className="journey-step__eyebrow">{item.step}</div>
                          <h3 className="journey-step__title journey-step__title--compact">{item.title}</h3>
                        </div>
                      </div>
                      <p className="journey-step__body">{item.detail}</p>
                      <div className="journey-step__preview">
                        <img
                          src={item.image}
                          alt={item.imageAlt}
                          loading="lazy"
                          decoding="async"
                          className="journey-step__preview-image"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="deferred-section relative px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14">
          <div className="mx-auto max-w-7xl">
            <div className="roadmap-shell">
              <div className="mx-auto max-w-3xl text-center">
                <h2
                  className="mt-6 font-syne text-white"
                  style={{ fontSize: "clamp(1.8rem, 3.8vw, 3rem)", lineHeight: "1.04", fontWeight: 700 }}
                >
                  Roadmap
                </h2>
              </div>

              <div className="roadmap-grid">
                {ROADMAP_COLUMNS.map((column) => (
                  <div key={column.title} className={`roadmap-track roadmap-track--${column.tone}`}>
                    <div className="roadmap-track__header">
                      <div className="roadmap-track__eyebrow">{column.subtitle}</div>
                      <div className="roadmap-track__title">{column.title}</div>
                      <div className="roadmap-track__lead">{column.lead}</div>
                    </div>

                    <div className="roadmap-track__items">
                      {column.items.map((item) => (
                        <div key={item.title} className="roadmap-card">
                          <div className="roadmap-card__row">
                            <span className={`roadmap-card__state${item.state === "Done" ? " roadmap-card__state--done" : ""}`}>{item.state}</span>
                          </div>
                          <div className="roadmap-card__title">{item.title}</div>
                        </div>
                      ))}
                    </div>

                    {column.subsections?.map((sub) => (
                      <div key={sub.heading} className="roadmap-track__subsection">
                        <div className="roadmap-track__subheading">{sub.heading}</div>
                        <div className="roadmap-track__items">
                          {sub.items.map((item) => (
                            <div key={item.title} className="roadmap-card">
                              <div className="roadmap-card__row">
                                <span className={`roadmap-card__state${item.state === "Done" ? " roadmap-card__state--done" : ""}`}>{item.state}</span>
                              </div>
                              <div className="roadmap-card__title">{item.title}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              <div className="roadmap-footer">
                {ROADMAP_FOOTER_SECTIONS.map((sub) => (
                  <div key={sub.heading} className="roadmap-footer__group">
                    <div className="roadmap-track__subheading">{sub.heading}</div>
                    <div className="roadmap-track__items">
                      {sub.items.map((item) => (
                        <div key={item.title} className="roadmap-card">
                          <div className="roadmap-card__row">
                            <span className={`roadmap-card__state${item.state === "Done" ? " roadmap-card__state--done" : ""}`}>{item.state}</span>
                          </div>
                          <div className="roadmap-card__title">{item.title}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="deferred-section relative px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14">
          <div className="mx-auto max-w-7xl">
            <div className="lux-panel p-4 sm:p-6 lg:p-8">
              <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
                <div className="max-w-2xl">
                  <h2
                    className="mt-6 font-syne text-white"
                    style={{ fontSize: "clamp(1.8rem, 3.8vw, 3rem)", lineHeight: "1.04", fontWeight: 700 }}
                  >
                    Multi-chain support across{" "}
                    <span className="hero-alive-accent">major ecosystems.</span>
                  </h2>
                </div>
                <p className="max-w-xl text-base leading-8 text-white/72 sm:text-lg">
                  BiorVault natively supports any EVM-compatible chain and any Cosmos SDK chain. Add custom networks instantly, directly inside the app.
                </p>
              </div>

              <div className="mt-8 grid gap-4 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
                <label className="search-shell">
                  <svg
                    className="pointer-events-none h-5 w-5 text-white/40"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <path d="M21 21l-4.35-4.35" strokeLinecap="round" />
                  </svg>
                  <input
                    type="text"
                    value={chainSearch}
                    onChange={(event) => setChainSearch(event.target.value)}
                    placeholder="Search chains..."
                    className="search-shell__input"
                  />
                </label>

                <div className="flex flex-wrap gap-2">
                  {CHAIN_FILTERS.map((filter) => (
                    <button
                      key={filter.key}
                      type="button"
                      onClick={() => setChainFilter(filter.key)}
                      className={`filter-pill ${chainFilter === filter.key ? "filter-pill--active" : ""}`}
                    >
                      {filter.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Reserve the height of the fully unfiltered grid at lg+ so
                  filtering/searching doesn't shrink the section and pull the
                  rest of the page up. */}
              <div className="mt-6 lg:min-h-[40rem]">
              {!hasVisibleChains ? (
                <div className="rounded-[1.75rem] border border-white/10 bg-white/[0.03] px-6 py-12 text-center text-sm text-white/52">
                  No chains match your search.
                </div>
              ) : (
                <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7">
                  {filteredChains.map((chain) => (
                    <div key={chain.name} className="chain-card">
                      <div className="chain-card__logo-wrap">
                        <img
                          src={chain.logo}
                          alt={chain.name}
                          loading="lazy"
                          decoding="async"
                          className="h-full w-full object-contain"
                        />
                      </div>
                      <div className="chain-card__name">{chain.name}</div>
                      <div className="chain-card__meta">{CHAIN_CATEGORY_LABELS[chain.category]}</div>
                    </div>
                  ))}

                  {showEvmCard ? (
                    <div className="chain-card chain-card--special">
                      <div className="chain-card__special-mark">∞</div>
                      <div className="chain-card__name">Any EVM Chain</div>
                      <div className="chain-card__meta">Custom support</div>
                    </div>
                  ) : null}

                  {showCosmosCard ? (
                    <div className="chain-card chain-card--special">
                      <div className="chain-card__special-mark">∞</div>
                      <div className="chain-card__name">Any Cosmos Chain</div>
                      <div className="chain-card__meta">Custom support</div>
                    </div>
                  ) : null}
                </div>
              )}
              </div>
            </div>
          </div>
        </section>

        <section className="deferred-section relative px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14">
          <div className="mx-auto max-w-7xl">
            <div className="partner-shell">
              <div className="mx-auto max-w-3xl text-center">
                <h2
                  className="mt-6 font-syne text-white"
                  style={{ fontSize: "clamp(1.8rem, 3.6vw, 2.9rem)", lineHeight: "1.06", fontWeight: 700 }}
                >
                  Built with{" "}
                  <span className="hero-alive-accent">industry leaders.</span>
                </h2>
              </div>

              <div className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                {PARTNERS.map((partner) => (
                  <a
                    key={partner.alt}
                    href={partner.href}
                    target="_blank"
                    rel="noreferrer"
                    className="partner-card"
                    aria-label={partner.alt}
                  >
                    <img
                      src={partner.src}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                      decoding="async"
                      className={`w-auto object-contain brightness-0 invert opacity-70 ${partner.imgClass}`}
                    />
                    <div className="partner-card__meta">{partner.meta}</div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>

        <BybTokenSection />

        <Footer />
      </div>

      <ApkModal
        isOpen={apkModalOpen}
        onClose={() => setApkModalOpen(false)}
        version={apk.version}
        url={apk.url}
        sha256={apk.sha256}
        signerSha256={apk.signerSha256}
      />
    </>
  );
};
